import { Plan } from '@zapier/design-system-revenue/src/types';
import { getCurrentPlanIndex } from './getCurrentPlanIndex';

export const getCurrentPlan = (
  plans: Array<Plan>,
  currentPlanId: number,
  isFall2019Pricing: boolean = false
): Plan | undefined | null =>
  plans[getCurrentPlanIndex(plans, currentPlanId, isFall2019Pricing)] || null;
